import { useMemo, useEffect } from 'react';

export function useEffectiveSelectedFile({ bloodTestFiles, selectedFile, selectFile }) {
    // Compute safe selected file index (clamps stale indices synchronously)
    const effectiveSelectedFile = useMemo(() => {
        if (selectedFile === "new") return "new";
        if (!bloodTestFiles || bloodTestFiles.length === 0) return "all";
        if (bloodTestFiles.length === 1 && selectedFile === "all") return 0;
        if (typeof selectedFile === 'number' && selectedFile >= bloodTestFiles.length) {
            return bloodTestFiles.length === 1 ? 0 : "all";
        }
        return selectedFile;
    }, [selectedFile, bloodTestFiles]);

    // Sync selectedFile state to match effectiveSelectedFile for UI consistency
    useEffect(() => {
        if (!bloodTestFiles) return;
        if (bloodTestFiles.length === 1 && selectedFile === "all") {
            selectFile(0);
        } else if (bloodTestFiles.length === 0 && selectedFile !== "new") {
            selectFile("all");
        } else if (typeof selectedFile === 'number' && selectedFile >= bloodTestFiles.length) {
            selectFile(bloodTestFiles.length === 1 ? 0 : "all");
        }
    }, [bloodTestFiles]);

    const selectedFileIndex = typeof effectiveSelectedFile === 'number' ? effectiveSelectedFile : null;

    return { effectiveSelectedFile, selectedFileIndex };
}
